import React from "react";
import { Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { MyHrPayrollYearlyDataTooltipTitle } from "my-hr/components";

interface MyHrPayrollYearlyDataTooltipProps {
  item: any; // Replace 'any' with the actual type if known
  [key: string]: any;
}

export const MyHrPayrollYearlyDataTooltip: React.FC<
  MyHrPayrollYearlyDataTooltipProps
> = ({ item, ...props }) => {
  const theme = useTheme();

  return (
    <Tooltip
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: theme.palette.darkBase.main,
            borderRadius: "8px",
          },
        },
        arrow: {
          sx: {
            color: theme.palette.darkBase.main,
          },
        },
      }}
      title={<MyHrPayrollYearlyDataTooltipTitle item={item} />}
      {...props}
    >
      {props.children}
    </Tooltip>
  );
};

export default MyHrPayrollYearlyDataTooltip;
